import { useTranslation } from 'react-i18next'

import EditWidgetForm from './EditWidgetForm'
import Widget from '../Widget'

export const usePERIODIC_NON_COMPLIANCES_CONFIG = () => {
  const { t } = useTranslation('common')

  return {
    id: 'PERIODIC_NON_COMPLIANCES_CONFIG',
    name: t('widgets.periodicNonCompliances.name'),
    description: t('widgets.periodicNonCompliances.description'),
    color: 'red',
    icon: 'RiLineChartLine',
    categories: [t('widgets.periodicNonCompliances.category')],
    previewWidth: '100%',

    initialState: {
      size: { width: 100, height: 400 },
      data: {
        presentation: 'line'
      }
    },

    Presentation: Widget,
    Form: EditWidgetForm
  }
}
